// data和removeData方法所用
const DATA_KEY = Symbol("data")

// 操作dom时遍历时的插入缓存key
const CACHE_INSERT_STATIC_KEY = "static"

export default {
  DATA_KEY,
  CACHE_INSERT_STATIC_KEY,
}
